import { JetView } from 'webix-jet';

/**
 * Class representing the details view for withdrawal requests.
 * @extends JetView
 */
export default class detailsWithdrawalRequestView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        // Main information form configuration
        const main_info = {
            margin: 10,
            rows: [
                {
                    view: 'text',
                    name: 'Id',
                    label: "<span class='icon-drivers-license-o'></span>" + _('Id'), // Label with icon
                    labelPosition: 'top',
                    placeholder: _('Id'),
                    invalidMessage: _('A ID is required'), // Validation message
                    disabled: screen.width > 500 && screen.height > 500 ? true : false, // Disable based on screen size
                },
                {
                    view: 'text',
                    name: 'Type',
                    label: _('Tipo'), // Label for Type
                    labelPosition: 'top',
                    placeholder: _('Tipo'),
                    disabled: screen.width > 500 && screen.height > 500 ? true : false,
                },
                {
                    view: 'text',
                    name: 'Date',
                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label with icon for Date
                    labelPosition: 'top',
                    placeholder: _('Fecha'),
                    disabled: screen.width > 500 && screen.height > 500 ? true : false,
                },
                {
                    view: 'text',
                    name: 'Amount',
                    label: _('Monto'), // Label for Amount
                    labelPosition: 'top',
                    placeholder: _('Monto'),
                    disabled: screen.width > 500 && screen.height > 500 ? true : false,
                    id: 'Monto', // ID for Amount field
                },
            ],
        };

        // Secondary information form configuration
        const second_main_info = {
            margin: 10,
            rows: [
                {
                    view: 'textarea',
                    name: 'PaymentSystemName',
                    label: _('Nombre sistema de pago'), // Label for Payment System Name
                    labelPosition: 'top',
                    placeholder: _('Nombre sistema de pago'),
                    disabled: true, // Disabled field
                },
            ],
        };

        // Left main section configuration
        const left_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info],
        };

        // Right main section configuration
        const rigth_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [second_main_info],
        };

        // Upper section configuration with multiview
        const upper_section = {
            multiview: true,
            scroll: true,
            cols: [left_main, { gravity: 1, minWidth: 5 }, rigth_main],
        };

        // Narrow upper section configuration
        const upper_section_narrow = {
            padding: 10,
            rows: [main_info],
        };

        // Window configuration for details withdrawal
        const detailsWithdrawal = webix.ui({
            view: 'window',
            move: true,
            id: 'detailsWithdrawal',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Detalles Avanzados'), // Advanced Details label
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide(); // Close window on click
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'dtDetails2',
                type: 'clean',
                rows: [upper_section_narrow],
            },
        });

        // Return the main form configuration
        return {
            view: 'form',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? upper_section // Use upper section for larger screens
                    : { height: 1, width: 0 }, // Placeholder for smaller screens
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance to set values on.
     */
    init(form) {
        this.on(this.app, 'withdrawTransDetail:select', (person) => {
            if (screen.width > 500 && screen.height > 500) {
                form.setValues(person); // Set form values for larger screens
                this.$$('Monto').setValue(
                    webix.i18n.priceFormat(person.Amount), // Format and set Amount value
                );
            } else {
                $$('dtDetails2').setValues(person); // Set values for smaller screens
            }
        });
    }
}

// FILE DOCUMENTED
